import {
  EmailWorkPacketsRequest,
  EmailReportsRequest,
  EmailMarineDocumentsRequest,
  EmailTruckDocumentsRequest,
  EmailRailDocumentsRequest,
} from "../models";
import { Post } from "./apiUtils";

const sendEmailWorkPacketsAsync = async (body: EmailWorkPacketsRequest) => {
  const response = await Post(
    `/api/email/workpackets/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailMarineReportsAsync = async (body: EmailReportsRequest) => {
  const response = await Post(
    `/api/email/marine/reports/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailTruckReportsAsync = async (body: EmailReportsRequest) => {
  const response = await Post(
    `/api/email/truck/reports/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailRailReportsAsync = async (body: EmailReportsRequest) => {
  const response = await Post(
    `/api/email/rail/reports/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailMarineDocumentsAsync = async (
  body: EmailMarineDocumentsRequest
) => {
  const response = await Post(
    `/api/email/marine/documents/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailTruckDocumentsAsync = async (
  body: EmailTruckDocumentsRequest
) => {
  const response = await Post(
    `/api/email/truck/documents/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

const sendEmailRailDocumentsAsync = async (body: EmailRailDocumentsRequest) => {
  const response = await Post(
    `/api/email/rail/documents/send`,
    JSON.stringify(body)
  );
  const result = await response.json();
  return result;
};

export const emailApi = {
  sendEmailWorkPacketsAsync,
  sendEmailMarineReportsAsync,
  sendEmailTruckReportsAsync,
  sendEmailRailReportsAsync,
  sendEmailMarineDocumentsAsync,
  sendEmailTruckDocumentsAsync,
  sendEmailRailDocumentsAsync,
};
